
import AppDropdown from '@/components/core/AppDropdown';

export default {
  i18nComponentKey: 'WidgetAddOnSizeRecommendationPopup.components.SizeRecommendationSizeFeedbackFilters',
  name: 'SizeRecommendationSizeFeedbackFilters',
  components: { AppDropdown },
  props: {
    filters: { type: Object, required: true },
    value: { type: Object, default: () => ({}) }
  },
  computed: {
    visibleFilters() {
      return [
        this.heightFilter(),
        this.weightFilter(),
        this.purchasedSizeFilter()
      ].filter(Boolean);
    }
  },
  methods: {
    heightFilter() {
      return this.optionTypeFilter(
        this.filters.height_filter,
        this.$t('height')
      );
    },
    weightFilter() {
      return this.optionTypeFilter(
        this.filters.weight_filter,
        this.$t('weight')
      );
    },
    optionTypeFilter(filter, title) {
      if (!filter) return null;

      return {
        ...filter,
        title,
        type: filter.is_number_field_type
          ? 'button_multiple_range'
          : 'button_multiple'
      };
    },
    purchasedSizeFilter() {
      const filter = this.filters.purchased_size_filter;
      if (!filter) return null;

      return {
        ...filter,
        title: this.$t('purchased_size'),
        type: 'button_multiple',
        unit: ''
      };
    }
  }
};
